import { useQuery } from '@apollo/client';
import React from 'react';
import {
  StaffApplicantSearchContainerApplicantApplicantUserResultsFieldsFragment,
  StaffApplicantSearchFilterContainerApplicantUserGetAllTagsDocument,
  StaffApplicantSearchFilterContainerEntitiesDocument,
  StaffApplicantSearchFilterContainerEntityFieldsFragment,
} from '../../../../generated';
import { ComponentQueryLoader } from '../../../shared/component-query-loader';
import { ApplicantSearchFilter } from './applicant-search-filter';

interface ApplicantSearchFilterContainerProps {
  filterDataCount: StaffApplicantSearchContainerApplicantApplicantUserResultsFieldsFragment;
  setRefreshQuery: React.Dispatch<React.SetStateAction<boolean>>;
}

export const ApplicantSearchFilterContainer: React.FC<ApplicantSearchFilterContainerProps> = (props) => {
  const refreshTagHandler = () => {
    refetchGetAllApplicantTags();
    props?.setRefreshQuery(true);
  };

  const { data: entitiesList, error: entitiesListError, loading: entitiesListLoading } = useQuery(StaffApplicantSearchFilterContainerEntitiesDocument);

  const {
    data: getAllApplicantTags,
    error: getAllApplicantTagsError,
    loading: getAllApplicantTagsLoading,
    refetch: refetchGetAllApplicantTags
  } = useQuery(StaffApplicantSearchFilterContainerApplicantUserGetAllTagsDocument);

  return (
    <div className="min-w-[220px] max-w-[300px]">
      <ComponentQueryLoader
        loading={entitiesListLoading || getAllApplicantTagsLoading}
        error={entitiesListError || getAllApplicantTagsError}
        hasData={entitiesList && getAllApplicantTags}
        hasDataComponent={
          <ApplicantSearchFilter
            entitiesList={entitiesList?.entities as StaffApplicantSearchFilterContainerEntityFieldsFragment[]}
            data={props?.filterDataCount}
            allTags={getAllApplicantTags?.applicantUserGetAllTags as string[]}
            refreshTagHandler={refreshTagHandler}
          />
        }
      />
    </div>
  );
};
